import { EcaSecaModel } from '../models/eca-seca-zones-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { ZoneLayerBase } from './zone-layer-base';

export class EcaSecaLayer extends ZoneLayerBase {
    async getZones(): Promise<ZoneFeature[]> {
        const zones = await EcaSecaModel!.getEcaSecaZones();
        return zones || [];
    }

    async initialize(): Promise<void> {
        await super.initialize();
        this.plot();
    }
    
    zoneId: string = "EcaSecaLayer";
}